export const DASHBOARD_ROLES = {
    SALES_AGENT: "sales_agent",
    SETTING_AGENT: "setting_agent",
    SALES_TEAM_LEAD: "sales_team_lead",
    SETTING_TEAM_LEAD: "setting_team_lead",
    CSO: "cso",
    CMO: "cmo",
    CONTROLLING: "controlling",
    DEVELOPER: "developer",
} as const;

export type DashboardRole = (typeof DASHBOARD_ROLES)[keyof typeof DASHBOARD_ROLES];

export const DASHBOARD_ROLE_LIST = [
    DASHBOARD_ROLES.SALES_AGENT,
    DASHBOARD_ROLES.SETTING_AGENT,
    DASHBOARD_ROLES.SALES_TEAM_LEAD,
    DASHBOARD_ROLES.SETTING_TEAM_LEAD,
    DASHBOARD_ROLES.CSO,
    DASHBOARD_ROLES.CMO,
    DASHBOARD_ROLES.CONTROLLING,
    DASHBOARD_ROLES.DEVELOPER,
] as const;

export const DASHBOARD_ROLE_LABEL_KEYS: Record<DashboardRole, string> = {
    [DASHBOARD_ROLES.SALES_AGENT]: "dashboard_role_sales_agent",
    [DASHBOARD_ROLES.SETTING_AGENT]: "dashboard_role_setting_agent",
    [DASHBOARD_ROLES.SALES_TEAM_LEAD]: "dashboard_role_sales_team_lead",
    [DASHBOARD_ROLES.SETTING_TEAM_LEAD]: "dashboard_role_setting_team_lead",
    [DASHBOARD_ROLES.CSO]: "dashboard_role_cso",
    [DASHBOARD_ROLES.CMO]: "dashboard_role_cmo",
    [DASHBOARD_ROLES.CONTROLLING]: "dashboard_role_controlling",
    [DASHBOARD_ROLES.DEVELOPER]: "dashboard_role_developer",
};

export type RolePreviewState = {
    permissions: string[];
    teamIds: string[];
    /** Explicit preset when multiple roles share the same permission set (e.g. CSO / CMO). */
    role?: DashboardRole;
};

export function isDashboardRole(value: string): value is DashboardRole {
    return DASHBOARD_ROLE_LIST.some((role) => role === value);
}

export type RoleDashboardProps = {
    role: DashboardRole;
};
